(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const menuBtn = $('[data-menu-toggle]');
  const nav = $('[data-nav]');
  const phoneMq = window.matchMedia('(max-width: 900px)');
  // Phone menu: fill the screen below the header, lock the page behind it
  const fitNav = () => {
    if (!nav || !nav.classList.contains('is-open') || !phoneMq.matches) { if (nav) nav.style.height = ''; return; }
    nav.style.height = `${Math.max(240, window.innerHeight - nav.getBoundingClientRect().top)}px`;
  };
  const setMenu = (open) => {
    nav.classList.toggle('is-open', open);
    menuBtn.setAttribute('aria-expanded', open);
    document.documentElement.classList.toggle('menu-open', open && phoneMq.matches);
    fitNav();
  };
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', () => setMenu(!nav.classList.contains('is-open')));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) { setMenu(false); menuBtn.focus(); }
    });
    window.addEventListener('resize', fitNav);
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', () => { if (!phoneMq.matches && nav.classList.contains('is-open')) setMenu(false); });
  }

  // Phone menu sections: tap to open, tap again to close; one open at a time
  $$('[data-nav-item] > a').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (!phoneMq.matches) return;
      e.preventDefault();
      const item = link.parentElement;
      const open = !item.classList.contains('is-open');
      $$('[data-nav-item].is-open').forEach((other) => {
        if (other === item) return;
        other.classList.remove('is-open');
        const a = other.querySelector(':scope > a');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
      item.classList.toggle('is-open', open);
      link.setAttribute('aria-expanded', open);
    });
  });

  // Header group: sticky bars, overlay offset, colour change on scroll
  const headerEl = $('[data-header]');
  const announcementEl = $('[data-announcement]');
  if (headerEl) {
    const root = document.documentElement;
    const headerWrap = headerEl.closest('.shopify-section') || headerEl.parentElement;
    const announcementWrap = announcementEl ? (announcementEl.closest('.shopify-section') || announcementEl.parentElement) : null;
    const announcementSticky = Boolean(announcementEl && announcementEl.classList.contains('announcement--sticky'));
    headerWrap.classList.toggle('is-sticky', headerEl.classList.contains('header--sticky'));
    headerWrap.classList.toggle('is-overlay', headerEl.classList.contains('header--overlay'));
    if (announcementWrap) announcementWrap.classList.toggle('is-sticky', announcementSticky);
    const measure = () => {
      root.style.setProperty('--header-h', `${headerEl.offsetHeight}px`);
      root.style.setProperty('--announcement-sticky-h', `${announcementSticky ? announcementEl.offsetHeight : 0}px`);
    };
    measure();
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(measure);
      ro.observe(headerEl);
      if (announcementEl) ro.observe(announcementEl);
    } else {
      window.addEventListener('resize', measure);
    }
    const onScroll = () => headerEl.classList.toggle('is-scrolled', window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  $$('[data-announcement]').forEach((bar) => {
    const items = $$('[data-announcement-item]', bar);
    if (items.length < 2) return;
    let index = 0;
    let timer;
    const go = (n) => {
      index = (n + items.length) % items.length;
      items.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        if (i === index) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
      });
    };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const start = () => {
      if (bar.dataset.autoplay !== 'true' || reduced) return;
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), Number(bar.dataset.speed || 5) * 1000);
    };
    $('[data-announcement-prev]', bar)?.addEventListener('click', () => { go(index - 1); start(); });
    $('[data-announcement-next]', bar)?.addEventListener('click', () => { go(index + 1); start(); });
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', () => clearInterval(timer));
    bar.addEventListener('focusout', start);
    start();
  });

  $$('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) + Number(btn.dataset.delta || 0));
      });
    });
  });

  const drawerMask = $('[data-drawer-mask]');
  const getDrawer = () => $('[data-cart-drawer]');
  const openDrawer = () => { getDrawer()?.classList.add('is-open'); drawerMask?.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const closeDrawer = () => { getDrawer()?.classList.remove('is-open'); drawerMask?.classList.remove('is-open'); document.body.style.overflow = ''; };
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Add-on lines (e.g. Alteration service) follow the garment they belong to: same quantity, removed together
  const syncAddons = async () => {
    const cart = await fetch(`${rootUrl}cart.js`).then((r) => r.json());
    const byKey = Object.fromEntries(cart.items.map((i) => [i.key, i]));
    const updates = {};
    cart.items.forEach((item) => {
      const forKey = item.properties && item.properties._for_key;
      if (!forKey) return;
      const parent = byKey[forKey];
      const want = parent ? parent.quantity : 0;
      if (want !== item.quantity) updates[item.key] = want;
    });
    if (Object.keys(updates).length) {
      await fetch(`${rootUrl}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    }
  };
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-cart-form]');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'checkout') return; // let Checkout go straight to Shopify
    e.preventDefault();
    const updates = {};
    $$('[data-line-qty]', form).forEach((input) => { updates[input.dataset.lineQty] = Math.max(0, Number(input.value) || 0); });
    try {
      await fetch(`${rootUrl}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      await syncAddons();
    } catch (err) { /* fall through to reload */ }
    window.location.reload();
  });

  const refreshCart = async () => {
    const res = await fetch(`${rootUrl}?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html');
    const fresh = html.querySelector('[data-cart-drawer]');
    const current = getDrawer();
    if (fresh && current) {
      if (current.classList.contains('is-open')) fresh.classList.add('is-open');
      current.replaceWith(fresh);
    }
    const cart = await fetch(`${rootUrl}cart.js`).then((r) => r.json());
    $$('[data-cart-count]').forEach((n) => { n.textContent = cart.item_count; });
  };

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      remove.disabled = true;
      try {
        await fetch(`${rootUrl}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
        });
        await syncAddons();
        await refreshCart();
        if (document.querySelector('[data-cart-form]')) window.location.reload();
      } catch (err) {
        window.location.href = window.theme.cartUrl;
      }
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeModal(); } });

  const modal = $('[data-quick-view]');
  const modalMask = $('[data-modal-mask]');
  const closeModal = () => { modal?.classList.remove('is-open'); modalMask?.classList.remove('is-open'); };
  modalMask?.addEventListener('click', closeModal);
  $('[data-close-modal]')?.addEventListener('click', closeModal);
  const bindQuickView = (scope) => $$('[data-quick-view-open]', scope).forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const title = btn.dataset.title || '';
      const price = btn.dataset.price || '';
      const img = btn.dataset.image || '';
      const url = btn.dataset.url || '#';
      const id = btn.dataset.variant || '';
      if (!modal) return;
      modal.querySelector('[data-qv-title]').textContent = title;
      modal.querySelector('[data-qv-price]').textContent = price;
      modal.querySelector('[data-qv-link]').href = url;
      const image = modal.querySelector('[data-qv-image]');
      if (img) { image.src = img; image.hidden = false; } else { image.hidden = true; }
      const hidden = modal.querySelector('[name="id"]');
      if (hidden) hidden.value = id;
      const single = btn.dataset.singleVariant === 'true';
      const available = btn.dataset.available !== 'false';
      const qvForm = modal.querySelector('[data-qv-form]');
      const qvOptions = modal.querySelector('[data-qv-options]');
      if (qvForm) qvForm.hidden = !(single && available);
      if (qvOptions) {
        qvOptions.hidden = single && available;
        qvOptions.href = url;
        qvOptions.textContent = available ? 'Choose options' : 'View details';
      }
      const qvError = modal.querySelector('[data-cart-error]');
      if (qvError) qvError.hidden = true;
      modal.classList.add('is-open');
      modalMask?.classList.add('is-open');
    });
  });
  bindQuickView(document);

  // Cards in "Top products": clicking the image or title opens quick view instead of leaving the page
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-card-quick-view] a');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const trigger = link.closest('[data-card-quick-view]').querySelector('[data-quick-view-open]');
    if (!trigger) return;
    e.preventDefault();
    trigger.click();
  });

  $$('[data-tabs]').forEach((tabs) => {
    tabs.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tab]');
      if (!btn) return;
      tabs.querySelectorAll('[data-tab]').forEach((b) => b.classList.toggle('is-active', b === btn));
      tabs.querySelectorAll('[data-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab));
    });
  });

  const sticky = $('[data-sticky-atc]');
  const trigger = $('[data-atc-trigger]');
  if (sticky && trigger) {
    const io = new IntersectionObserver((entries) => {
      sticky.classList.toggle('is-on', !entries[0].isIntersecting);
    });
    io.observe(trigger);
  }

  $$('[data-slideshow]').forEach((show) => {
    const slides = $$('.slideshow__slide', show);
    if (slides.length < 2) return;
    let i = 0;
    const go = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s, idx) => { s.style.display = idx === i ? 'grid' : 'none'; }); };
    go(0);
    $('[data-slide-next]', show)?.addEventListener('click', () => go(i + 1));
    $('[data-slide-prev]', show)?.addEventListener('click', () => go(i - 1));
  });

  // Shoppable hero: one card open at a time; tap outside, the close button or Escape closes it
  const closeHotspots = (except) => $$('[data-hotspot].is-open').forEach((wrap) => {
    if (wrap === except) return;
    wrap.classList.remove('is-open');
    wrap.querySelector('.hotspot')?.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('[data-hotspot] .hotspot');
    if (dot) {
      const wrap = dot.closest('[data-hotspot]');
      closeHotspots(wrap);
      const open = wrap.classList.toggle('is-open');
      dot.setAttribute('aria-expanded', String(open));
      return;
    }
    if (e.target.closest('[data-hotspot-close]') || !e.target.closest('[data-hotspot-card]')) closeHotspots();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeHotspots(); });

  // Collection tabs: switch panels, arrow-scroll the product row
  // Home page product sections: show a different random mix on each visit (in stock first)
  $$('[data-shuffle]').forEach((wrap) => {
    const limit = Number(wrap.dataset.shuffle) || 0;
    const cards = $$('.product-card', wrap).filter((c) => c.parentElement === wrap);
    if (!limit || cards.length <= limit) return;
    const shuffle = (arr) => { for (let i = arr.length - 1; i > 0; i -= 1) { const k = Math.floor(Math.random() * (i + 1)); [arr[i], arr[k]] = [arr[k], arr[i]]; } return arr; };
    const inStock = shuffle(cards.filter((c) => c.dataset.available !== 'false'));
    const soldOut = cards.filter((c) => c.dataset.available === 'false');
    const keep = inStock.slice(0, limit);
    if (keep.length < limit) keep.push(...soldOut.slice(0, limit - keep.length));
    cards.forEach((c) => { if (!keep.includes(c)) c.remove(); });
    keep.forEach((c) => wrap.appendChild(c));
  });

  $$('[data-collection-tabs]').forEach((root) => {
    const tabs = $$('[data-ctab]', root);
    const panels = $$('[data-cpanel]', root);
    const updateArrows = (panel) => {
      const track = panel.querySelector('[data-ctrack]');
      const prev = panel.querySelector('[data-cprev]');
      const next = panel.querySelector('[data-cnext]');
      if (!track || !prev || !next) return;
      const max = track.scrollWidth - track.clientWidth;
      prev.hidden = track.scrollLeft <= 4;
      next.hidden = max <= 4 || track.scrollLeft >= max - 4;
    };
    const select = (i, focus) => {
      tabs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', String(n === i));
        t.tabIndex = n === i ? 0 : -1;
      });
      panels.forEach((p, n) => { p.hidden = n !== i; p.classList.toggle('is-active', n === i); });
      if (focus) tabs[i].focus();
      updateArrows(panels[i]);
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => { select(i); remember(); });
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true);
      });
    });
    panels.forEach((panel) => {
      const track = panel.querySelector('[data-ctrack]');
      if (!track) return;
      const step = () => track.clientWidth * 0.9;
      panel.querySelector('[data-cprev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      panel.querySelector('[data-cnext]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', () => updateArrows(panel), { passive: true });
    });
    window.addEventListener('resize', () => panels.forEach((p) => { if (!p.hidden) updateArrows(p); }));
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        const i = tabs.indexOf(e.target);
        if (i > -1) select(i);
      });
    }
    const storeKey = `sutra-tabs:${window.location.pathname}:${$$('[data-collection-tabs]').indexOf(root)}`;
    const remember = () => {
      try {
        const active = panels.findIndex((p) => !p.hidden);
        const track = panels[active]?.querySelector('[data-ctrack]');
        sessionStorage.setItem(storeKey, JSON.stringify({ tab: active, left: track ? track.scrollLeft : 0 }));
      } catch (err) { /* storage unavailable */ }
    };
    root.addEventListener('click', (e) => { if (e.target.closest('a')) remember(); });
    try {
      const saved = JSON.parse(sessionStorage.getItem(storeKey) || 'null');
      if (saved && tabs[saved.tab]) {
        select(saved.tab);
        const track = panels[saved.tab].querySelector('[data-ctrack]');
        if (track && saved.left) { track.style.scrollBehavior = 'auto'; track.scrollLeft = saved.left; track.style.scrollBehavior = ''; }
      }
    } catch (err) { /* storage unavailable */ }
    const first = panels.findIndex((p) => !p.hidden);
    if (first > -1) updateArrows(panels[first]);
  });

  $$('[data-countdown]').forEach((el) => {
    const out = el.querySelector('[data-cd]');
    const endTime = new Date(el.dataset.countdown).getTime();
    if (!out || Number.isNaN(endTime)) { el.hidden = true; return; }
    let timer;
    const tick = () => {
      const diff = endTime - Date.now();
      if (diff <= 0) { out.textContent = 'Sale ended'; clearInterval(timer); return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const sec = Math.floor((diff % 60000) / 1000);
      out.textContent = `${d}d  ${h}h  ${m}m  ${sec}s`;
    };
    tick();
    timer = setInterval(tick, 1000);
  });

  const popup = $('[data-popup]');
  const popupSeen = () => { try { return sessionStorage.getItem('sutra-popup'); } catch (err) { return null; } };
  const markPopupSeen = () => { try { sessionStorage.setItem('sutra-popup', '1'); } catch (err) { /* storage unavailable */ } };
  if (popup && !popupSeen() && !document.documentElement.classList.contains('from-social')) {
    setTimeout(() => popup.classList.add('is-open'), 1800);
    popup.querySelectorAll('[data-close-popup]').forEach((el) => el.addEventListener('click', () => {
      popup.classList.remove('is-open');
      markPopupSeen();
    }));
    popup.querySelector('form')?.addEventListener('submit', markPopupSeen);
  }

  // Product page: variant picker (buttons or dropdowns), price, stock status, gallery
  $$('[data-product]').forEach((root) => {
    const json = root.querySelector('[data-product-variants]');
    const variants = json ? JSON.parse(json.textContent) : [];
    const groups = $$('[data-option-group]', root);
    const idInput = root.querySelector('[data-variant-id]');
    const addBtn = root.querySelector('[data-add-button]');
    const priceEl = root.querySelector('[data-product-price]');
    const stickyPrice = $('[data-sticky-price]');
    const stickyBtn = $('[data-sticky-button]');
    const mainImage = root.querySelector('[data-product-image]');
    const stock = root.querySelector('[data-stock]');
    const thumbs = $$('[data-thumb]', root);

    const showImage = (src, srcset, alt) => {
      if (!mainImage || !src) return;
      if (srcset) mainImage.srcset = srcset; else mainImage.removeAttribute('srcset');
      mainImage.src = src;
      if (alt) mainImage.alt = alt;
    };
    const markThumb = (active) => thumbs.forEach((t) => {
      t.classList.toggle('is-active', t === active);
      if (t === active) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      showImage(thumb.dataset.full, thumb.dataset.srcset, thumb.dataset.alt);
      markThumb(thumb);
    }));

    const updateStock = (variant) => {
      if (!stock) return;
      const text = stock.querySelector('[data-stock-text]');
      const threshold = Number(stock.dataset.threshold || 0);
      let state = 'in';
      if (!variant || !variant.available) state = 'out';
      else if (threshold > 0 && variant.qty !== null && variant.qty <= threshold) state = 'low';
      stock.dataset.state = state;
      text.textContent = state === 'out' ? stock.dataset.textOut : state === 'low' ? stock.dataset.textLow : stock.dataset.textIn;
    };

    const chosenValues = () => groups.map((group) => {
      const select = group.querySelector('select[data-option-input]');
      if (select) return select.value;
      const checked = group.querySelector('input[data-option-input]:checked');
      return checked ? checked.value : null;
    });
    const currentVariant = () => {
      if (!groups.length) return variants.find((v) => String(v.id) === String(idInput?.value)) || variants[0];
      const chosen = chosenValues();
      return variants.find((v) => v.options.every((o, idx) => o === chosen[idx]));
    };
    const update = (userChange) => {
      const variant = currentVariant();
      const ok = Boolean(variant && variant.available);
      if (addBtn) {
        addBtn.disabled = !ok;
        addBtn.textContent = ok ? addBtn.dataset.labelAdd : (variant ? addBtn.dataset.labelSoldOut : (addBtn.dataset.labelUnavailable || addBtn.dataset.labelSoldOut));
      }
      if (stickyBtn) stickyBtn.disabled = !ok;
      updateStock(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = `<div class="price">${variant.compare ? `<span class="price--compare">${variant.compare}</span>` : ''}<span>${variant.price}</span></div>`;
      }
      if (stickyPrice) stickyPrice.innerHTML = variant.price;
      if (userChange) {
        if (variant.image) {
          showImage(variant.image);
          const base = variant.image.split('?')[0];
          markThumb(thumbs.find((t) => (t.dataset.full || '').split('?')[0] === base) || null);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };
    const syncLabels = () => groups.forEach((group) => {
      const out = group.querySelector('[data-option-value]');
      if (!out) return;
      const select = group.querySelector('select[data-option-input]');
      const checked = group.querySelector('input[data-option-input]:checked');
      out.textContent = select ? select.value : (checked ? checked.value : '');
    });
    groups.forEach((group) => group.addEventListener('change', () => { syncLabels(); update(true); }));
    update(false);

    // Alteration add-on: open/close the panel, enable its fields, show the combined price on the button
    const alter = root.querySelector('[data-alter]');
    if (alter) {
      const toggle = alter.querySelector('[data-alter-toggle]');
      const fields = $$('[data-alter-field]', alter);
      const fee = Number(alter.dataset.alterPrice) || 0;
      const money = (cents) => {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' }).format(cents / 100); }
        catch (err) { return `$${(cents / 100).toFixed(2)}`; }
      };
      const relabel = () => {
        if (!addBtn || addBtn.disabled) return;
        const variant = currentVariant();
        const on = toggle.checked;
        addBtn.textContent = on && variant && variant.price_cents != null ? `${addBtn.dataset.labelAdd} · ${money(variant.price_cents + fee)}` : addBtn.dataset.labelAdd;
      };
      toggle.addEventListener('change', () => {
        alter.classList.toggle('is-on', toggle.checked);
        fields.forEach((f) => { f.disabled = !toggle.checked; });
        const err = alter.querySelector('[data-alter-error]'); if (err) err.hidden = true;
        relabel();
        if (toggle.checked) { const phone = alter.querySelector('[data-alter-phone]'); if (phone) phone.focus(); }
      });
      groups.forEach((group) => group.addEventListener('change', relabel));
    }
  });

  // Back link: go back in history (the browser restores the scroll position) when the shopper came from this store
  $$('[data-back-link]').forEach((link) => {
    let fromStore = false;
    try {
      const ref = document.referrer ? new URL(document.referrer) : null;
      fromStore = Boolean(ref && ref.origin === window.location.origin && window.history.length > 1);
      if (fromStore) {
        const target = new URL(link.href, window.location.origin);
        const samePage = ref.pathname.replace(/\/$/, '') === target.pathname.replace(/\/$/, '');
        if (!samePage && link.dataset.labelGeneric) link.querySelector('[data-back-text]').textContent = link.dataset.labelGeneric;
      }
    } catch (err) { fromStore = false; }
    link.addEventListener('click', (e) => {
      if (!fromStore || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      window.history.back();
    });
  });

  // Newsletter: add the typed first name to the WhatsApp sign-up message
  $$('[data-newsletter-wa]').forEach((link) => {
    const baseHref = link.getAttribute('href');
    link.addEventListener('click', () => {
      const scope = link.closest('[data-newsletter]');
      const field = scope && scope.querySelector('[data-newsletter-wa-name]');
      const name = field ? field.value.trim() : '';
      const template = link.dataset.nameText || '';
      if (!name || !template) { link.setAttribute('href', baseHref); return; }
      link.setAttribute('href', baseHref + encodeURIComponent(' ' + template.replace('[name]', name)));
    });
  });

  // Contact page: send by email (Shopify contact form) or open the message in WhatsApp
  $$('[data-contact]').forEach((root) => {
    const wrap = root.querySelector('[data-contact-form]');
    const form = wrap && wrap.querySelector('form');
    const submit = root.querySelector('[data-contact-submit]');
    const hint = root.querySelector('[data-contact-hint]');
    const email = root.querySelector('[data-contact-email]');
    if (!form || !submit) return;
    const channel = () => wrap.dataset.channel || 'email';
    const apply = (value) => {
      wrap.dataset.channel = value;
      submit.textContent = value === 'whatsapp' ? submit.dataset.labelWhatsapp : submit.dataset.labelEmail;
      if (hint) hint.textContent = value === 'whatsapp' ? hint.dataset.hintWhatsapp : hint.dataset.hintEmail;
      if (email) email.required = value !== 'whatsapp';
    };
    $$('[data-contact-channel]', root).forEach((radio) => {
      radio.addEventListener('change', () => { if (radio.checked) apply(radio.value); });
      if (radio.checked) apply(radio.value);
    });
    form.addEventListener('submit', (e) => {
      if (channel() !== 'whatsapp') return;
      e.preventDefault();
      const val = (sel) => { const el = root.querySelector(sel); return el ? el.value.trim() : ''; };
      const lines = [submit.dataset.waIntro || ''];
      const name = val('[data-contact-name]');
      const subject = val('[data-contact-subject]');
      const phone = val('[data-contact-phone]');
      const mail = val('[data-contact-email]');
      const body = val('[data-contact-body]');
      if (subject) lines.push('Subject: ' + subject);
      if (body) lines.push('', body);
      const who = [];
      if (name) who.push(name);
      if (mail) who.push(mail);
      if (phone) who.push(phone);
      if (who.length) lines.push('', who.join(' | '));
      const url = 'https://wa.me/' + submit.dataset.wa + '?text=' + encodeURIComponent(lines.filter((l, i, a) => l !== '' || a[i - 1] !== '').join('\n'));
      window.open(url, '_blank', 'noopener');
    });
    const ok = root.querySelector('[data-contact-success]');
    if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
  });

  // Collection page: reveal the next batch of products (all products are on one page so sold-out items stay last)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-show-more]');
    if (!btn) return;
    const step = Number(btn.dataset.step) || 24;
    const hidden = $$('[data-more-card][hidden]');
    hidden.slice(0, step).forEach((slot) => { slot.hidden = false; });
    const left = hidden.length - Math.min(step, hidden.length);
    const count = btn.querySelector('[data-show-more-count]');
    if (count) count.textContent = String(left);
    if (left <= 0) btn.closest('.collection-more')?.remove();
  });

  // Popups built on <dialog> (size chart)
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog && dialog.showModal) dialog.showModal(); else if (dialog) dialog.setAttribute('open', '');
      return;
    }
    const closer = e.target.closest('[data-dialog-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  // Share: copy link
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    const label = btn.textContent;
    try {
      await navigator.clipboard.writeText(btn.dataset.copyLink);
      btn.textContent = 'Link copied';
    } catch (err) {
      btn.textContent = btn.dataset.copyLink;
    }
    setTimeout(() => { btn.textContent = label; }, 2500);
  });

  $$('[data-localization-select]').forEach((sel) => sel.addEventListener('change', () => sel.form.submit()));

  $('[data-sort-select]')?.addEventListener('change', (e) => e.target.form.submit());

  // Collection filters: update the grid in place (falls back to a normal page load)
  const initFacets = () => {
    const wrap = $('[data-facets-section]');
    if (!wrap) return;
    const form = $('[data-facets-form]', wrap);
    const sectionId = wrap.dataset.sectionId;
    const openDrawer = () => { wrap.classList.add('facets-open'); document.body.style.overflow = 'hidden'; };
    const closeFilters = () => { wrap.classList.remove('facets-open'); document.body.style.overflow = ''; };

    const load = async (url, push) => {
      wrap.classList.add('is-loading');
      try {
        const target = new URL(url, window.location.origin);
        const fetchUrl = new URL(target);
        fetchUrl.searchParams.set('section_id', sectionId);
        const res = await fetch(fetchUrl.toString());
        if (!res.ok) throw new Error(String(res.status));
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = html.querySelector('[data-facets-section]');
        if (!fresh) throw new Error('missing section');
        const wasOpen = wrap.classList.contains('facets-open');
        const openGroups = $$('details.facet', wrap).map((d) => d.open);
        const focusName = document.activeElement && document.activeElement.name;
        wrap.innerHTML = fresh.innerHTML;
        $$('details.facet', wrap).forEach((d, i) => { if (openGroups[i] !== undefined) d.open = openGroups[i] || d.open; });
        if (focusName) { const again = wrap.querySelector(`[name="${CSS.escape(focusName)}"]`); if (again && again.type === 'number') again.focus(); }
        if (push) window.history.pushState({ facets: true }, '', target.toString());
        wrap.classList.toggle('facets-open', wasOpen);
        bindQuickView(wrap);
      } catch (err) {
        window.location.href = url;
        return;
      } finally {
        wrap.classList.remove('is-loading');
      }
    };

    const urlFromForm = () => {
      const currentForm = $('[data-facets-form]', wrap);
      const params = new URLSearchParams();
      new FormData(currentForm).forEach((value, key) => { if (value !== '') params.append(key, value); });
      const action = currentForm.getAttribute('action') || window.location.pathname;
      const query = params.toString();
      return query ? `${action}?${query}` : action;
    };

    let priceTimer;
    wrap.addEventListener('change', (e) => {
      if (!e.target.closest('[data-facets-form]')) return;
      clearTimeout(priceTimer);
      load(urlFromForm(), true);
    });
    wrap.addEventListener('input', (e) => {
      if (e.target.type !== 'number' || !e.target.closest('[data-facets]')) return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(() => load(urlFromForm(), true), 700);
    });
    wrap.addEventListener('submit', (e) => {
      if (!e.target.matches('[data-facets-form]')) return;
      e.preventDefault();
      load(urlFromForm(), true);
    });
    wrap.addEventListener('click', (e) => {
      if (e.target.closest('[data-facets-open]')) { openDrawer(); return; }
      if (e.target.closest('[data-facets-close]')) { closeFilters(); return; }
      const link = e.target.closest('[data-facet-link], .pagination a, .empty-state .page a, .empty-state .next a, .empty-state .prev a');
      if (link && link.href && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        load(link.href, true).then(() => {
          if (!link.matches('[data-facet-link]')) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
    window.addEventListener('popstate', () => load(window.location.href, false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeFilters(); });
  };
  initFacets();


  // Product recommendations are only available through the recommendations endpoint
  $$('[data-recommendations]').forEach(async (el) => {
    if (!el.dataset.productId || el.children.length) return;
    try {
      const url = `${window.theme.recommendationsUrl}?section_id=${el.dataset.sectionId}&product_id=${el.dataset.productId}&limit=4`;
      const text = await fetch(url).then((r) => r.text());
      const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; bindQuickView(el); }
    } catch (err) { /* recommendations are optional */ }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.js-ajax-cart, [data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const errorEl = form.querySelector('[data-cart-error]');
    const submitBtn = e.submitter || form.querySelector('[type="submit"]');
    if (errorEl) errorEl.hidden = true;
    // Alteration add-on: the panel lives outside the form but posts with it (form="…")
    const alterRoot = form.closest('[data-product]') || document;
    const alter = alterRoot.querySelector(`[data-alter]`);
    const alterOn = alter && alter.querySelector('[data-alter-toggle]')?.checked;
    if (alterOn) {
      const phone = alter.querySelector('[data-alter-phone]');
      const err = alter.querySelector('[data-alter-error]');
      if (!phone.value.trim()) { if (err) err.hidden = false; phone.focus(); return; }
      const note = alter.querySelector('[data-alter-note]');
      if (note) note.disabled = !note.value.trim();
    }
    const wasDisabled = submitBtn ? submitBtn.disabled : false;
    if (submitBtn) submitBtn.disabled = true;
    try {
      const res = await fetch(`${window.theme.cartAddUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) {
        if (errorEl) { errorEl.textContent = data.description || data.message || 'Could not add to bag.'; errorEl.hidden = false; }
        return;
      }
      if (alterOn && alter.dataset.alterVariant) {
        const qty = Number(new FormData(form).get('quantity')) || 1;
        const label = data.variant_title && data.variant_title !== 'Default Title' ? `${data.product_title} (${data.variant_title})` : data.product_title;
        await fetch(`${window.theme.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(alter.dataset.alterVariant), quantity: qty, properties: { For: label, _for_key: data.key } })
        });
      }
      await refreshCart();
      closeModal();
      openDrawer();
    } catch (err) {
      form.submit();
    } finally {
      if (submitBtn) submitBtn.disabled = wasDisabled;
    }
  });
})();
